import { CurrencySymbolPipe } from 'src/app/modules/shared/pipes/currency-symbol.pipe';
import { TimeZoneService } from './../services/timezone.service';
import { Pipe, PipeTransform } from '@angular/core';
import { WorkflowModelsNS } from '../../../misc/workflow/models/add-update-workflow.models';
import { CUSTOMFIELD_TYPE_IDS } from '../constants/typeId';
import { DatePipe } from '@angular/common';
@Pipe({ name: 'wfUFValue', pure: false })
export class WorkflowUpdateFieldValuePipe implements PipeTransform {

    constructor(
        private timeZoneService: TimeZoneService,
        private currencySymbolPipe: CurrencySymbolPipe
    ) {}

    transform(updateFieldDetails: WorkflowModelsNS.WorkflowAddEditActionUpdateFields): any {

        const noValue = "No Value";

        if((updateFieldDetails?.fieldValue || updateFieldDetails?.fieldValue=='0') && updateFieldDetails?.formControlId){

            const formControlId = updateFieldDetails.formControlId;

            if((!updateFieldDetails?.fieldValue && updateFieldDetails?.fieldValue!='0')){
                return noValue;
            }

            if (formControlId === CUSTOMFIELD_TYPE_IDS.CHECKBOX) {
                const value = JSON.parse(updateFieldDetails.fieldValue)||[];
                return value?.length>0 ? value.join(', ') : noValue;
            } else if (formControlId === CUSTOMFIELD_TYPE_IDS.DATE_PICKER) {
                return new DatePipe('en-US').transform(updateFieldDetails?.fieldValue,'MM/dd/yyyy');
                // if(['expectedDate'].includes(updateFieldDetails.fieldName) && updateFieldDetails?.fieldValue){
                //     return this.timeZoneService.formateToUserDate(updateFieldDetails?.fieldValue,'date');
                // }else{
                //     return new DatePipe('en-US').transform(updateFieldDetails?.fieldValue,'MM/dd/yyyy');
                // }

            } else if (formControlId === CUSTOMFIELD_TYPE_IDS.DATETIMEPICKER) {
                return this.timeZoneService.formateToUserDate(updateFieldDetails?.fieldValue,'MM/DD/YYYY | h:mm a',false);
            } else if (formControlId === CUSTOMFIELD_TYPE_IDS.TIME) {
                return this.timeZoneService.onlyTime(updateFieldDetails?.fieldValue);
            } else if (formControlId === CUSTOMFIELD_TYPE_IDS.DROPDOWN || formControlId === CUSTOMFIELD_TYPE_IDS.USERLOOKUP) {
                const value = JSON.parse(updateFieldDetails.fieldValue)||{};
                return value?.name||noValue;
            } else if (formControlId === CUSTOMFIELD_TYPE_IDS.TOOGLE_BUTTON) {
                return updateFieldDetails?.fieldValue=='true' ? 'Yes' : 'No';
            } else if (formControlId === CUSTOMFIELD_TYPE_IDS.MULTISELECT) {
                let value = JSON.parse(updateFieldDetails.fieldValue)||[];
                value = value.map(x=> x?.name);
                return value?.length>0 ? value.join(', ') : noValue;
            } else if(updateFieldDetails.fieldName=='repConfidence') {
                return `${updateFieldDetails?.fieldValue}%`;
            } else if(updateFieldDetails.fieldValueType==WorkflowModelsNS.WorkflowUpdateFieldValueType.Expression) {
                return `= ${updateFieldDetails?.fieldValue}`;
            } else if(formControlId === CUSTOMFIELD_TYPE_IDS.CURRENCY) {
                return this.currencySymbolPipe.transform(updateFieldDetails?.fieldValue , null, updateFieldDetails?.currencySymbol);
            } else if(formControlId === CUSTOMFIELD_TYPE_IDS.PERCENTAGE) {
                return `${updateFieldDetails?.fieldValue}%`;
            } else {
                return updateFieldDetails?.fieldValue;
            }
        }

        return noValue;
    }

 }
